export default "__VITE_ASSET__Cb3yV7wv__"